import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=800304ec&scoped=true&"
import script from "./notFound.vue?vue&type=script&lang=js&"
export * from "./notFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800304ec",
  null
  
)

export default component.exports